'use strict';

var Feature = require('./Feature');

/**
 * @constructor
 * @extends Feature
 */
var RowResizing = Feature.extend('RowResizing', {
    /**
     * Row being resized
     * @type {number}
     * @default
     * @memberOf RowResizing.prototype
     */
    dragRow: null,

    /**
     * the pixel location of the where the drag was initiated
     * @type {number}
     * @default
     * @memberOf RowResizing.prototype
     */
    dragStart: -1,

    /**
     * the starting width/height of the row/column we are dragging
     * @type {number}
     * @default -1
     * @memberOf RowResizing.prototype
     */
    dragStartHeight: -1,

    /**
     * the max row height
     * @type {number}
     * @default Infinity
     * @memberOf RowResizing.prototype
     */
    maxDragHeight: Infinity,

    /**
     * @memberOf RowResizing.prototype
     * @desc get the mouse x,y coordinate
     * @returns {number}
     * @param {MouseEvent} event - the mouse event to query
     */
    getMouseValue: function(event) {
        return event.primitiveEvent.detail.mouse.y;
    },

    /**
     * @function
     * @memberOf RowResizing.prototype
     * @desc returns the index of which divider I'm over
     * @returns {number}
     * @param {Hypergrid} grid
     * @param {Object} event - the event details
     */
    overAreaDivider: function(grid, event) {
        return event.isDataCell && event.mousePoint.y <= 3 ||
            event.mousePoint.y >= event.bounds.height - 3;
    },

    /**
     * @function
     * @memberOf RowResizing.prototype
     * @desc return the cursor name
     * @returns {string}
     */
    getCursorName: function() {
        return 'row-resize';
    },

    /**
     * @memberOf RowResizing.prototype
     * @param {Hypergrid} grid
     * @param {Object} event - the event details
     */
    handleMouseDrag: function(grid, event) {
        if (this.dragRow !== null) {
            var delta = this.getMouseValue(event) - this.dragStart;
            var height = Math.min(this.maxDragHeight, this.dragStartHeight + delta);
            grid.behavior.setRowHeight(this.dragRow, height);
        } else if (this.next) {
            this.next.handleMouseDrag(grid, event);
        }
    },

    /**
     * @memberOf RowResizing.prototype
     * @param {Hypergrid} grid
     * @param {Object} event - the event details
     */
    handleMouseDown: function(grid, event) {
        if (event.isDataRow && event.isHandleCell && this.overAreaDivider(grid, event)) {
            if (event.mousePoint.y <= 3) {
                // Get previous row
                var rowIndex = event.dataCell.y - 1;
                // -1 is the header row
                if (rowIndex < 0) {
                   return;
                }
                this.dragRow = rowIndex;
                this.dragStartHeight = grid.renderer.visibleRows[event.gridCell.y - 1].height;
            } else {
                this.dragRow = event.dataCell.y;
                this.dragStartHeight = event.bounds.height;
            }
            this.maxDragHeight = grid.renderer.getVisibleScrollHeight() - 40;
            this.dragStart = this.getMouseValue(event);
        } else if (this.next) {
            this.next.handleMouseDown(grid, event);
        }
    },

    /**
     * @memberOf RowResizing.prototype
     * @param {Hypergrid} grid
     * @param {Object} event - the event details
     */
    handleMouseUp: function(grid, event) {
        if (this.dragRow !== null) {
            this.cursor = null;
            this.dragRow = null;

            event.primitiveEvent.stopPropagation();

            grid.synchronizeScrollingBoundaries();
        } else if (this.next) {
            this.next.handleMouseUp(grid, event);
        }
    },

    /**
     * @memberOf RowResizing.prototype
     * @param {Hypergrid} grid
     * @param {Object} event - the event details
     */
    handleMouseMove: function(grid, event) {
        if (this.dragRow === null) {
            this.cursor = null;

            if (this.next) {
                this.next.handleMouseMove(grid, event);
            }

            this.cursor = !event.isHeaderRow && event.isHandleCell && this.overAreaDivider(grid, event) ? this.getCursorName() : null;
        }
    },

    /**
     * @param {Hypergrid} grid
     * @param {CellEvent} cellEvent
     * @memberOf RowResizing.prototype
     */
    handleDoubleClick: function(grid, event) {
        if (!event.isHeaderRow && event.isHandleCell && this.overAreaDivider(grid, event)) {
            if (event.mousePoint.y <= 3) {
                // Get previous row
                var rowIndex = event.dataCell.y - 1;
                // -1 is the header row
                if (rowIndex < 0) {
                   return;
                }
                grid.behavior.resetRowHeight(rowIndex);
            } else {
                grid.behavior.resetRowHeight(event.dataCell.y);
            }
        } else if (this.next) {
            this.next.handleDoubleClick(grid, event);
        }
    },

    /**
     * @function
     * @memberOf RowResizing.prototype
     * @desc am I over the column/row area
     * @returns {boolean}
     * @param {Hypergrid} grid
     * @param {Object} event - the event details
     */
    isFirstFixedOtherArea: function(grid, event) {
        return this.isFirstFixedColumn(grid, event);
    }

});

module.exports = RowResizing;
